import { AppDispatcher } from 'services/PubSub';
import { actionsType } from 'config/constants';
import ReviewsService from 'services/Reviews'

let ids = [];
let timeout = null;
let cacheRatings = null;
const updateRatings = (id) => {
    
    if(ids.indexOf(id) == -1) {
        ids.push(id);
        clearTimeout(timeout);
    } else {
        return Promise.resolve(cacheRatings)
    }

    timeout = setTimeout(() => {
        cacheRatings = ReviewsService.getProductRating(ids.toString()).then((payload)=> {
            if(!payload || payload.status) return false;
            AppDispatcher.dispatch({
                type: actionsType.STORES.UPDATE_RATING,
                payload
            })
            ids = [];
            cacheRatings = null;
        })
    }, 100);

    
}


const actions = {
    setLoading: (value) => {
        setTimeout(() => {
            AppDispatcher.dispatch({
                type: actionsType.STORES.SET_LOADING_RATING,
                payload: value
            });
        }, 0);
    },
    getRatings(id) {
        return updateRatings(id)
    }
}

export default actions